import api from 'Application/api/api';

const editProjectDefaults = (signal, values) =>
	api.put('/project-preferences', values, {
		signal,
	});

export default editProjectDefaults;
